import clsx from "clsx";
import { ComponentType } from "react";
import { useTranslation } from "react-i18next";

type Props = {
  titleKey: string;
  subtitleKey: string;
  icon: ComponentType;
  stylesHeader: string;
  stylesText: string;
};

export const HomeCardHeader = ({
  titleKey,
  subtitleKey,
  icon: Icon,
  stylesHeader,
  stylesText,
}: Props) => {
  const { t } = useTranslation();

  return (
    <div
      className={clsx("home-card-header rounded-t-lg", stylesHeader)}
      data-testid="home-card-header"
    >
      <div className={clsx("home-card-icon", stylesText)} data-testid="home-card-icon">
        <Icon />
      </div>
      <div className="home-card-title">
        <span className="home-card-title-main">{t(titleKey)}</span>
        <span className="home-card-title-sub">{t(subtitleKey)}</span>
      </div>
    </div>
  );
};
